import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pp-lottery-winnings" }
const _hoisted_2 = ["innerHTML"]

import { ref } from "vue";
import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import DsDropdown from "@sazka/design-system/src/forms/components/ds-dropdown.vue";
import { DsDropdownItemModel } from "@sazka/design-system/src/forms/components/ds-dropdown/ds-dropdown-models";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-keno-winnings',
  setup(__props) {

const options: DsDropdownItemModel[] = Array.from({ length: 6 }, (_, index) => ({
    value: index,
    label: `SÁZKA NA ${7 - index} ${LotteryParser.getNumberLabel(7 - index).toUpperCase()}`,
}));

const selectedOption = ref(0);

const winningOrdersGrid = [
    [
        [7, 10000],
        [6, 200],
        [5, 12],
        [4, 3],
        [3, 2],
        [2, 1],
    ],
    [
        [6, 2000],
        [5, 100],
        [4, 12],
        [3, 2],
        [2, 1],
    ],
    [
        [5, 200],
        [4, 16],
        [3, 3],
        [2, 2],
    ],
    [
        [4, 100],
        [3, 11],
        [2, 2],
    ],
    [
        [3, 12],
        [2, 2],
        [1, 1],
    ],
    [
        [2, 9],
        [1, 1],
    ],
];

const formatMultiple = (multiple: number) => `${StringUtils.formatNumber(multiple)}x`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DsDropdown, {
      modelValue: selectedOption.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOption).value = $event)),
      options: _unref(options),
      id: "winnings-dropdown"
    }, null, 8, ["modelValue", "options"]),
    _createVNode(DsTable, null, {
      default: _withCtx(() => [
        _createVNode(DsRow, null, {
          default: _withCtx(() => [
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Pořadí")
              ])),
              _: 1,
              __: [1]
            }),
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Uhodnutá čísla")
              ])),
              _: 1,
              __: [2]
            }),
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Výherní násobek")
              ])),
              _: 1,
              __: [3]
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(winningOrdersGrid[selectedOption.value], (order, index) => {
          return (_openBlock(), _createBlock(DsRow, { key: index }, {
            default: _withCtx(() => [
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(index + 1) + ". pořadí", 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(order[0]), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createElementVNode("strong", {
                    innerHTML: formatMultiple(order[1])
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})